import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { EditIcon } from './_Styled'
import Caption1 from '../../typography/captions/Caption1'
import Caption4 from '../../typography/captions/Caption4'
import { activityEditFields } from '../../../constants/activity'

const ActivityEditText = styled(Caption4)`
  margin-left: 10px;
  width: 675px;
  padding: 13px 0;
  display: flex;
`

const StyledActivityEditEventItem = styled.li`
  height: 100%;
  margin: 0 !important;
  display: flex;
  display: flex;
  align-items: center;
`

const AcrtivityEditEventItem = ({ attribute }) => (
  <StyledActivityEditEventItem className="activity-edit-item">
    <EditIcon />
    <ActivityEditText className="activity-edit-text">
      {activityEditFields[attribute].label}
      <Caption1>&nbsp;&nbsp;edited</Caption1>
    </ActivityEditText>
  </StyledActivityEditEventItem>
)

AcrtivityEditEventItem.propTypes = {
  attribute: PropTypes.string.isRequired
}

export default AcrtivityEditEventItem



// WEBPACK FOOTER //
// ./src/components/quest/questhistory/ActivityEditEventItem.js